import React from "react";

interface OwnTracksConfigProps {
  urlConfig: string;
}

const OwnTracksConfig: React.FC<OwnTracksConfigProps> = ({ urlConfig }) => {
  return (
    <div className="configuration">
      <div className="configuration-container">
        <p className="step">
          We do not have recent coordinates from your phone.
        </p>
        <p className="step">Step 1: Install the OwnTracks app</p>
        <div className="app-links">
          <a
            href="https://apps.apple.com/us/app/owntracks/id692424691?itsct=apps_box_badge&amp;itscg=30200"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=org.owntracks.android&hl=en&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
            />
          </a>
        </div>
        <p className="step">Step 2: Configure OwnTracks</p>
        <p>
          <a href={urlConfig}>Click here to configure OwnTracks</a>
        </p>
        <p className="step">Step 3: Make sure OwnTracks is running</p>
      </div>
    </div>
  );
};

export default OwnTracksConfig;
